// Auth service — pure data layer, framework-agnostic.
import { http } from "./http";

export const authService = {
  me: () => http.get("/api/auth/me").then((r) => r.data),
  login: (email, password, remember_device = false) =>
    http.post("/api/auth/login", { email, password, remember_device }).then((r) => r.data),
  twoFactorVerify: (code) =>
    http.post("/api/auth/two-factor/verify", { code }).then((r) => r.data),
  logout: () => http.post("/api/auth/logout").then((r) => r.data),
  register: (payload) => http.post("/api/auth/register", payload).then((r) => r.data),
  verifyEmail: (token) => http.post("/api/auth/verify-email", { token }).then((r) => r.data),
  resendVerification: (email) =>
    http.post("/api/auth/resend-verification", { email }).then((r) => r.data),
  forgotPassword: (email) =>
    http.post("/api/auth/forgot-password", { email }).then((r) => r.data),
  resetPassword: (token, password) =>
    http.post("/api/auth/reset-password", { token, password }).then((r) => r.data),
  passwordStrength: (password) =>
    http.post("/api/auth/password-strength", { password }).then((r) => r.data),
};
